// extracted by mini-css-extract-plugin
export default {"wrapper":"Kah_U5_lOwx0sdMXdpWz"};